import { Vue, Component, Watch, Prop, Provide } from 'vue-property-decorator';
import MiniPageTable from './listBase';
import MiniPageEdit from './edit';
import { IPSService } from '@/services/ipsServices';
import { QinggerLibUtils } from '@/util';
const isset = QinggerLibUtils.isset;

@Component({
  components: {
    MiniPageTable,
    MiniPageEdit,
  },
})
export default class MiniBasePage extends Vue {
  showTable = true;

  pageId = 0;

  // 0 编辑 1 查看
  state = 0;

  // 网点 商品分类列表
  classList = [];

  // 运营模式 1 镜单  2 镜千 3 云单 4 云千
  @Provide()
  get mode() {
    return Number(+this.$route.params.mode);
  }

  @Provide()
  get isMoreSite() {
    return Number(+this.$route.params.isMoreSite);
  }

  @Provide()
  goodsClassList() {
    return this.classList;
  }

  @Provide()
  openCoupon() {
    return this.coupon;
  }

  siteId = 0;

  // 是否开启优惠券
  coupon = 0;

  get serviceIndex() {
    let result = +this.$route.params.mode;
    if (!this.siteId) {
      result = 2;
    }
    return result;
  }

  async mounted() {
    this.siteId = +this.$route.params.siteId;
    this.siteId && (this.coupon = await this.getCouponConfig());
    this.siteId && (this.classList = await this.getGoodsClassList());
  }

  // 获取优惠券配置
  getCouponConfig() {
    return IPSService.siteGroupConfig({
      postParams: {
        sgId: +this.$route.params.sgId || +this.$route.params.id,
      },
    }).then((res) => {
      return res.isOpenExchangeCoupon || 0;
    });
  }

  getGoodsClassList() {
    return IPSService.siteClassList({
      postParams: {
        siteId: this.siteId,
      },
    }).then((response) => {
      return isset(response, 'list') ? response.list : [];
    });
  }

  onEdit(pageId, state) {
    this.pageId = pageId;
    this.state = state;
    this.showTable = !this.showTable;
  }

  onCancel() {
    this.showTable = !this.showTable;
  }

  onSave(pageId = 0) {
    if (!pageId) {
      this.showTable = !this.showTable;
    } else {
      this.pageId = pageId;
    }
  }

  render(h) {
    return (
      <div style="height: 100%">
        <MiniPageTable v-model={this.showTable} serviceIndex={this.serviceIndex} onEdit={this.onEdit.bind(this)} />
        <MiniPageEdit v-model={this.showTable} siteId={this.siteId} classList={this.classList} mode={this.mode} pageId={this.pageId} isDisabled={!!this.state} onCancel={this.onCancel.bind(this)} onSave={this.onSave.bind(this)} />
      </div>
    );
  }
}
